import classnames from 'classnames';
import React, { HtmlHTMLAttributes } from 'react';
import { useConfig } from '@/configProvider';
import { useLocale } from '@/i18n';
import { MeidouInfoType } from '@/types';
import './index.less';

interface IProps extends HtmlHTMLAttributes<HTMLDivElement> {
    /**
     * 按钮样式
     */
    style?: React.CSSProperties;
    /**
     * 美豆信息
     */
    meidouInfo: MeidouInfoType | null;
    /**
     * 美豆按钮空态文案(未登录态或者美豆为0下的文案)
     */
    emptyText?: string;
    onClick?: () => void;
    /**
     * 是否使用新 UI
     */
    useNewUi?: boolean;
    /**
     * 是否只展示icon
     */
    isOnlyIcon?: boolean;
}

const MeidouInfoBtn = (props: IProps) => {
    const { style = {}, meidouInfo, emptyText, onClick, useNewUi, isOnlyIcon } = props;
    const { isIntl, appName } = useConfig();

    const { $t } = useLocale();

    const emptyTextStr = emptyText || $t((v) => v.meidouInfo.emptyText);

    const isDesignKitGlobal = isIntl && appName === 'designkit';

    const coinIconUrl = isIntl
        ? appName === 'designkit'
            ? 'https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/meidouInfo/meidou-coin.png'
            : 'https://x-design-static-release.stariicloud.com/xdesign-widgets/images/meidou-info/credit.png'
        : 'https://public.static.meitudata.com/xiuxiu-pc/xdesign-widgets/images/meidouInfo/meidou-icon.svg';

    // TODO: 商务要求先放开美豆顶导入口，后续再调整
    // if ((isTeam && (!currentTeamIdentity || currentTeamIdentity?.type === IdentityType.ENTERPRISE)) || !meidouInfo)
    //     return null;
    if (!meidouInfo) return null;

    return (
        <div
            className={classnames('xdesign-meidou-info__btn', {
                'xdesign-meidou-info__btn--intl': isIntl,
                'xdesign-meidou-info__btn--intl-designkit': isIntl && appName === 'designkit',
                'xdesign-meidou-info__btn--new': useNewUi,
            })}
            style={{ ...style }}
            onClick={onClick}
        >
            <img src={coinIconUrl} className="xdesign-meidou-info__btn-icon" alt="" />
            {!isOnlyIcon && (
                <span className="xdesign-meidou-info__btn-text">
                    {meidouInfo?.available_amount || isDesignKitGlobal
                        ? `${meidouInfo?.available_amount}`
                        : emptyTextStr}
                </span>
            )}
        </div>
    );
};
export default MeidouInfoBtn;
